import React from "react";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import {withStyles} from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import {Table} from "@material-ui/core";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import PropTypes from "prop-types";
import { t } from '../../i18n';

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
    fullWidth : {
        width: '100%',
        borderRadius: 0
    },
}));

class SwmsPartThree extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            swmsRelatesTo: props.state.swmsRelatesTo,
        };
        this.onChange = this.onChange.bind(this);
    }

    onChange(event) {
        this.props.onChangeHandler();
        this.setState({
            ...this.state, [event.target.name]: event.target.value
        });
    }

    render() {
        let {state} = this;

        return <Grid container spacing={0}>
            <Grid item xs={7}>
                <Paper square style={{ padding: "30px", height: "100%" }}>
                    <label htmlFor="title" style={{float: "left", textAlign: "right", clear: "both", marginRight: "15px"}}>{ t('swms.relatesToLabel') }</label>
                    <TextField
                        style={{width: "300px", marginTop: "-16px", marginBottom: "24px"}}
                        margin="normal"
                        id="swmsRelatesTo"
                        label=""
                        name="swmsRelatesTo"
                        value={state.swmsRelatesTo}
                        onChange={this.onChange}
                    />
                    <br/>
                    { t('swms.partThree.disclaimer') }
                </Paper>
            </Grid>
            <Grid item xs={5}>
                <Paper square style={{ padding: "30px", height: "100%" }}>
                    <p><b>{ t('swms.partThree.highRiskHeading') }</b></p>
                    <p>
                        <ul style={{ listStyle: "square inside url('data:image/gif;base64,R0lGODlhBQAKAIABAAAAAP///yH5BAEAAAEALAAAAAAFAAoAAAIIjI+ZwKwPUQEAOw==')" }}>
                            <li>{ t('swms.highRiskItems.movingPlant') }</li>
                            <li>{ t('swms.highRiskItems.pressurisedGas') }</li>
                            <li>{ t('swms.highRiskItems.confinedSpaces') }</li>
                            <li>{ t('swms.highRiskItems.asbestos') }</li>
                            <li>{ t('swms.highRiskItems.workingAtHeights') }</li>
                            <li>{ t('swms.highRiskItems.structuralAlterations') }</li>
                        </ul>
                    </p>
                </Paper>
            </Grid>
            <Grid item xs={12} style={{ backgroundColor: 'lightblue', padding: "30px" }}>
                <Typography component="h6" variant="subtitle1">
                    { t('swms.ppe.heading') }
                </Typography>
                <Typography component="h6" variant="subtitle2">
                    { t('swms.ppe.subtext') }
                </Typography>
            </Grid>
            <Grid item xs={12} style={{ padding: "30px" }}>
                <Typography component="p" variant="subtitle2">
                    { t('swms.partThree.as1319Info') }
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Table>
                    <TableHead>
                        <tr>
                            <th style={{ padding: "20px" }}>{ t('swms.ppe.foot') }</th>
                            <th style={{ padding: "20px" }}>{ t('swms.ppe.hearing') }</th>
                            <th style={{ padding: "20px" }}>{ t('swms.ppe.highVisibility') }</th>
                            <th style={{ padding: "20px" }}>{ t('swms.ppe.head') }</th>
                            <th style={{ padding: "20px" }}>{ t('swms.ppe.eye') }</th>
                            <th style={{ padding: "20px" }}>{ t('swms.ppe.face') }</th>
                            <th style={{ padding: "20px" }}>{ t('swms.ppe.hand') }</th>
                            <th style={{ padding: "20px" }}>{ t('swms.ppe.protectiveClothing') }</th>
                            <th style={{ padding: "20px" }}>{ t('swms.ppe.sunProtection') }</th>
                        </tr>
                    </TableHead>
                    <TableBody>
                        <tr>
                            <td style={{ padding: "20px" }}><img alt="Foot Protection" style={{ width: "64px" }} src="/images/swms/footProtection.png"/></td>
                            <td style={{ padding: "20px" }}><img alt="Hearing Protection" style={{ width: "64px" }} src="/images/swms/hearingProtection.png"/></td>
                            <td style={{ padding: "20px" }}><img alt="High Visability" style={{ width: "64px" }} src="/images/swms/highVisibility.png"/></td>
                            <td style={{ padding: "20px" }}><img alt="Head Protection" style={{ width: "64px" }} src="/images/swms/headProtection.png"/></td>
                            <td style={{ padding: "20px" }}><img alt="Eye Protection" style={{ width: "64px" }} src="/images/swms/eyeProtection.png"/></td>
                            <td style={{ padding: "20px" }}><img alt="Face Protection" style={{ width: "64px" }} src="/images/swms/faceProtection.png"/></td>
                            <td style={{ padding: "20px" }}><img alt="Hand Protection" style={{ width: "64px" }} src="/images/swms/handProtection.png"/></td>
                            <td style={{ padding: "20px" }}><img alt="Protective Clothing" style={{ width: "64px" }} src="/images/swms/protectiveClothing.png"/></td>
                            <td style={{ padding: "20px" }}>{ t('swms.ppe.sunProtectionDetails') }</td>
                        </tr>
                        <tr>
                            <td colSpan="9" style={{ padding: "20px" }}>
                                { t('swms.partThree.ppeNotes') }
                            </td>
                        </tr>
                    </TableBody>
                </Table>
            </Grid>
        </Grid>;
     }
 }

SwmsPartThree.propTypes = {
    onChangeHandler: PropTypes.func.isRequired,
};

export default withStyles(classes)(SwmsPartThree);